const API_URL = process.env.VUE_APP_API_DOMAIN;

// storage
const STORAGE = {
  ACCESS_TOKEN: "AccessToken",
  REFRESH_TOKEN: "RefreshToken",
  TOKEN_TIME: "TokenTime"
};

const RESPONSE_CODE = {
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  UNAUTHORIZED: 401,
  ERROR_SERVER: 500
};

export { API_URL, STORAGE, RESPONSE_CODE };
